import React from "react";
import { withStyles } from "@material-ui/styles";
import { Grid, FormHelperText } from "@material-ui/core";
import { connect } from "react-redux";
import LazyLoader from "../../lib/lazyLoader";
import { ourProductList } from "../../containers/Home/homeConstants";
import { LOGIN } from "../../routes/RouteConstants";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  heading: {
    ...theme.typography.defaultFont,
    fontSize: "8px",
    lineHeight: "10px",
    fontWeight: 400,
    textAlign: "center",
    color: "#000000",
    ["@media (min-width:576px)"]: {
      fontSize: "11px",
      lineHeight: "13px"
    }
  },
  logos: {
    margin: "10px",
    display: "inline-block",
    ["@media (max-width:576px)"]: {
      margin: "8px"
    }
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    width: "100vw",
    overflowX: "scroll",
    scrollbarWidth: "none",
    ["-webkit-overflow-scrolling"]: "touch",
    ["-ms-overflow-style"]: "none",
    ["&::-webkit-scrollbar"]: {
      display: "none !important",
      backgroundColor: "transparent",
      height: 0,
      width: 0
    },
    ["&::-webkit-scrollbar-track"]: {
      backgroundColor: "transparent"
    },
    ["&::-webkit-scrollbar-thumb"]: {
      backgroundColor: "transparent"
    }
  },
  logoContainerDesktop: {
    display: "flex",
    alignItems: "center"
  }
});

class OurPartners extends React.Component {
  startPostingJob = () => {
    Router.push(LOGIN);
  };
  render() {
    const { classes, deviceType } = this.props;
    const isMobile = deviceType === "mobile";

    return (
      <div className={classes.root}>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item>
            <span className={classes.heading}>
              Other Products by InfoEdge India Ltd.
            </span>
          </Grid>
          <Grid
            item
            className={
              isMobile ? classes.logoContainer : classes.logoContainerDesktop
            }
          >
            {ourProductList.map((item, index) => (
              <a
                href={item.url}
                target="_blank"
                rel={item.no_follow ? "nofollow" : null}
                key={`ourpartner${index}`}
              >
                <img
                  data-src={item.image_source}
                  alt={item.title}
                  border="0"
                  className={classes.logos}
                  height={isMobile ? item.mobile_height : item.desktop_height}
                  width={isMobile ? item.mobile_width : item.desktop_width}
                />
              </a>
            ))}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  deviceType: state.commonReducer.deviceType
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(LazyLoader(OurPartners)));
